import { useState } from 'react'

import { t } from '../i18n/lingua'

/**
 * La variante lunga del comando Windows, per chi non ha `curl.exe` (Windows
 * Server 2016): appunta il certificato in PowerShell. Chiusa di default — il
 * comando principale è quello di due righe con `curl.exe`, che c'è da Windows
 * 10 e da Server 2019.
 */
export function VarianteSenzaCurl({ comando }: { comando?: string | null }) {
  const [copiato, setCopiato] = useState(false)
  if (!comando) return null
  return (
    <details className="guida-chiave" style={{ marginTop: 8 }}>
      <summary>{t('Windows Server 2016 o senza curl.exe')}</summary>
      <div className="guida-chiave__corpo">
        <p className="field__hint" style={{ marginTop: 0 }}>
          {t('Stesso risultato senza curl.exe: il certificato si verifica in PowerShell. Incolla tutte le righe insieme.')}
        </p>
        <pre className="mono" style={{ overflowX: 'auto', padding: 12, whiteSpace: 'pre' }}>{comando}</pre>
        <button type="button" className="secondary" onClick={() => {
          void navigator.clipboard?.writeText(comando)
          setCopiato(true)
        }}>
          {copiato ? t('Copiato') : t('Copia il comando')}
        </button>
      </div>
    </details>
  )
}
